import { createAsyncThunk } from '@reduxjs/toolkit';
import { iStateMessage } from '@/customTypes/GenericReduxTypes';
import { iGenericResponse } from '@/customTypes/CommonServiceTypes';
import { curryGetThunkName } from '@/projectUtils/ReduxUtil';
import { adminBulkImport } from '@/services/api/cresivoxServer';
import { REDUCER_NAME } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const importProductForReseller = createAsyncThunk<
  iGenericResponse<any>,
  { wholesalerId: string; increaseprice: string; resellerId: string },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName('importProductForReseller'),
  async ({ wholesalerId, increaseprice, resellerId }, { rejectWithValue }) => {
    try {
      const response = await adminBulkImport.importProductForReseller(
        wholesalerId,
        { increaseprice, resellerId }
      );
      if (response.httpStatusCode===202) {
        return response;
      }

      // ❌ REAL FAILURE
      return rejectWithValue({
        httpStatusCode: response?.httpStatusCode ?? 400,
        message:response?.responseBody?.error ??
          'Wholesaler import failed',
      });

    } catch (error: any) {
      return rejectWithValue({
        httpStatusCode: 500,
        message: error?.message || 'Unexpected error occurred',
      });
    }
  }
);

// httpStatusCode

  export const getImportResellerList = createAsyncThunk<
  iGenericResponse<any>,
  { search?: string } | void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getImportResellerList"),
  // @ts-expect-error
  async (args, { rejectWithValue }) => {
    try {
      const response = await adminBulkImport.getImportResellerList(
        // @ts-expect-error
        args?.search
      );

      if (response?.httpStatusCode === 200) {
        return {
          httpStatusCode: response.httpStatusCode,
          data: response.data.data,
          message: response.message,
        };
      }

      return rejectWithValue({
        httpStatusCode: response.httpStatusCode,
        message: response.message,
      });
    } catch (error: any) {
      return rejectWithValue({
        message: error?.message || "Something went wrong",
      });
    }
  }
);
